import { API_V4_BASE_URL } from 'settings';
import { get, makeRequest, put } from './api';
import { toastError } from 'utils/reduxToast';
import { ILesson } from 'interface/lesson';
import { IDownload } from 'interface/filedownload';

export const fetchLesson = (lessonId: number): Promise<ILesson> => {
  return get({
    url: `/learner/lessons/${lessonId}`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data.data)
    .catch(() => toastError('Não é possível acessar essa aula no momento'));
};

export const fetchLessonFiles = (lessonId: number): Promise<IDownload[]> => {
  return get({
    url: `/learner/lessons/${lessonId}/files`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data.data)
    .catch(() => toastError('Não é possível acessar essa aula no momento'));
};

export const downloadLessonFile = (fileId: number) => {
  return get({
    url: `/download/file/${fileId}`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data)
    .catch(() => toastError('Não é possível baixar esse arquivo no momento'));
};

export const downloadLessonAudio = (audioId: number) => {
  return get({
    url: `/download/audio/${audioId}`,
    baseURL: API_V4_BASE_URL,
  })
    .then((response) => response.data)
    .catch(() => toastError('Não é possível escutar esse áudio no momento'));
};

export const manualWatchLesson = (lessonId: Number, watched: boolean) => {
  return put({ url: `/learner/lessons/${lessonId}/manualWatchLesson`, baseURL: API_V4_BASE_URL, data: { watched } })
          .catch(err => toastError('Não foi possível executar essa ação no momento'));
};

export const fetchRating = (lessonId: number) => {
  return get({ url: `/learner/lessons/${lessonId}/ratings`, validateStatus: () => true }).then(
    (response) => response.data.data
  );
};

export const sendRating = (lessonId: number, rating: number) => {
  return makeRequest({
    method: rating ? 'POST' : 'PUT',
    url: `/learner/lessons/${lessonId}/ratings`,
    data: { rating },
  }).then((response) => response.data.data);
};
